import { render, staticRenderFns } from "./CompanyFiltersVars.vue?vue&type=template&id=4a0c8b0c&"
import script from "./CompanyFiltersVars.vue?vue&type=script&lang=ts&"
export * from "./CompanyFiltersVars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0c8b0c')) {
      api.createRecord('4a0c8b0c', component.options)
    } else {
      api.reload('4a0c8b0c', component.options)
    }
    module.hot.accept("./CompanyFiltersVars.vue?vue&type=template&id=4a0c8b0c&", function () {
      api.rerender('4a0c8b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyFiltersVars.vue"
export default component.exports